<template>
    <div class="login"> 
        <div> 
            <div class="login-logo">
                <p class="login-logo__text">CL project</p>
            </div>
            
            <login-form/>
        </div>
    </div>
</template>

<script> 
import loginForm from '../../components/forms/loginForm';

export default {
    components: {
        loginForm
    }
}
</script>

<style lang="scss">
@import '@/assets/scss/main.scss';

.login {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 10vh;

    &-logo {
        text-align: center;

        &__text {
            font-size: 30px;
            font-weight: 600;
            color: $mainColor;
            margin-bottom: 25px;
        }
    }
} 
</style>